// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppDrawer-module__menu--B_m7c {
    width: 350px;
    max-height: 70vh;
    position: relative;
    transition: width 0.3s;
    z-index: 1;
    background-color: transparent;
    grid-column: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
}

.AppDrawer-module__menu--B_m7c.AppDrawer-module__closed--HdtB1 {
    width: 60px;
}

.AppDrawer-module__menu--B_m7c.AppDrawer-module__overlay--fmYGm {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 350px;
    background-color: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    padding: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.AppDrawer-module__backdrop--B2DTY {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 900;
}

.AppDrawer-module__bottomMenu--Kat9r {
    margin-top: auto;
}

.AppDrawer-module__menuItem--EZ2QN {
    border-radius: 8px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.AppDrawer-module__menuItem--EZ2QN.AppDrawer-module__dev--k0qxI {
    background-color: rgba(255, 255, 255, 0.1);
}

.AppDrawer-module__menuItem--EZ2QN.AppDrawer-module__dev--k0qxI>div {
    color: rgba(184, 178, 178, 0.637);
}


.AppDrawer-module__menuItem--EZ2QN.AppDrawer-module__selected--dEuBK {
    background-color: white;
    color: #90909A;
    box-shadow: 1px 9px 22px -1px rgba(34, 60, 80, 0.17);
}

.AppDrawer-module__menuItem--EZ2QN:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.AppDrawer-module__menuItemIcon--d1mdT {
    color: #90909A !important;
}

.AppDrawer-module__menuItemIcon--d1mdT.AppDrawer-module__selected--dEuBK {
    color: #326CFD !important;
}

.AppDrawer-module__menuItemIcon--d1mdT.AppDrawer-module__selected--dEuBK>span {
    font-weight: bold;
}

.AppDrawer-module__menuItemText--bigE4 {
    color: #90909A;
}

.AppDrawer-module__menuItemText--bigE4.AppDrawer-module__selected--dEuBK {
    color: #326CFD;
}

.AppDrawer-module__menuItemText--bigE4.AppDrawer-module__selected--dEuBK>span {
    font-weight: bold;
}

.AppDrawer-module__menuItem--EZ2QN.AppDrawer-module__selected--dEuBK::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background-color: #326CFD;
    border-radius: 8px 0 0 8px;
}

.AppDrawer-module__menuHeaderOpen--_VCmd>.AppDrawer-module__logoContainer--SZV1q {
    width: 250px;
}

.AppDrawer-module__menuHeaderOpen--_VCmd>.AppDrawer-module__logoContainer--SZV1q img {
    width: 100%;
    height: auto;
}

.AppDrawer-module__menuHeaderClose--tQ4ie>.AppDrawer-module__logoContainer--SZV1q {
    width: 36px;
    padding: 10px;
}

.AppDrawer-module__menuHeaderClose--tQ4ie>.AppDrawer-module__logoContainer--SZV1q img {
    width: 100%;
    height: auto;
}

.AppDrawer-module__menuHeaderOpen--_VCmd {
    display: flex;
    justify-content: space-between;
}

.AppDrawer-module__menuHeaderClose--tQ4ie {
    display: flex;
    flex-direction: column;
}

.AppDrawer-module__iconMenu--hTPZY>svg {
    color: #90909A;
    font-size: 30px;
}

.AppDrawer-module__menuItemText--bigE4 {
    color: #90909A;
    position: relative;
}

.AppDrawer-module__menuItemText--bigE4 span {
    display: inline-block;
    position: relative;
}

.AppDrawer-module__newIcon--y28yo {
    position: absolute;
    top: -12px;
    padding: 1px 6px;
    background-color: #326CFD;
    border-radius: 4px;
    font-size: 10px;
    color: white;
    z-index: 1;
    left: 0px;
    padding: 0px 4px;
}
.AppDrawer-module__hasUnreadMessages--FVdJo {
    background-color: red;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/shared/app-drawer/AppDrawer.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;AACvD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iCAAiC;AACrC;;;AAGA;IACI,uBAAuB;IACvB,cAAc;IACd,oDAAoD;AACxD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".menu {\r\n    width: 350px;\r\n    max-height: 70vh;\r\n    position: relative;\r\n    transition: width 0.3s;\r\n    z-index: 1;\r\n    background-color: transparent;\r\n    grid-column: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n}\r\n\r\n.menu.closed {\r\n    width: 60px;\r\n}\r\n\r\n.menu.overlay {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    z-index: 1000;\r\n    width: 350px;\r\n    background-color: white;\r\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\r\n    padding: 10px;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n\r\n.backdrop {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    z-index: 900;\r\n}\r\n\r\n.bottomMenu {\r\n    margin-top: auto;\r\n}\r\n\r\n.menuItem {\r\n    border-radius: 8px;\r\n    margin-bottom: 10px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.menuItem.dev {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.menuItem.dev>div {\r\n    color: rgba(184, 178, 178, 0.637);\r\n}\r\n\r\n\r\n.menuItem.selected {\r\n    background-color: white;\r\n    color: #90909A;\r\n    box-shadow: 1px 9px 22px -1px rgba(34, 60, 80, 0.17);\r\n}\r\n\r\n.menuItem:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.menuItemIcon {\r\n    color: #90909A !important;\r\n}\r\n\r\n.menuItemIcon.selected {\r\n    color: #326CFD !important;\r\n}\r\n\r\n.menuItemIcon.selected>span {\r\n    font-weight: bold;\r\n}\r\n\r\n.menuItemText {\r\n    color: #90909A;\r\n}\r\n\r\n.menuItemText.selected {\r\n    color: #326CFD;\r\n}\r\n\r\n.menuItemText.selected>span {\r\n    font-weight: bold;\r\n}\r\n\r\n.menuItem.selected::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 4px;\r\n    background-color: #326CFD;\r\n    border-radius: 8px 0 0 8px;\r\n}\r\n\r\n.menuHeaderOpen>.logoContainer {\r\n    width: 250px;\r\n}\r\n\r\n.menuHeaderOpen>.logoContainer img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.menuHeaderClose>.logoContainer {\r\n    width: 36px;\r\n    padding: 10px;\r\n}\r\n\r\n.menuHeaderClose>.logoContainer img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.menuHeaderOpen {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.menuHeaderClose {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.iconMenu>svg {\r\n    color: #90909A;\r\n    font-size: 30px;\r\n}\r\n\r\n.menuItemText {\r\n    color: #90909A;\r\n    position: relative;\r\n}\r\n\r\n.menuItemText span {\r\n    display: inline-block;\r\n    position: relative;\r\n}\r\n\r\n.newIcon {\r\n    position: absolute;\r\n    top: -12px;\r\n    padding: 1px 6px;\r\n    background-color: #326CFD;\r\n    border-radius: 4px;\r\n    font-size: 10px;\r\n    color: white;\r\n    z-index: 1;\r\n    left: 0px;\r\n    padding: 0px 4px;\r\n}\r\n.hasUnreadMessages {\r\n    background-color: red;\r\n    border-radius: 50%;\r\n    width: 10px;\r\n    height: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n    position: absolute;\r\n    left: 30px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `AppDrawer-module__menu--B_m7c`,
	"closed": `AppDrawer-module__closed--HdtB1`,
	"overlay": `AppDrawer-module__overlay--fmYGm`,
	"backdrop": `AppDrawer-module__backdrop--B2DTY`,
	"bottomMenu": `AppDrawer-module__bottomMenu--Kat9r`,
	"menuItem": `AppDrawer-module__menuItem--EZ2QN`,
	"dev": `AppDrawer-module__dev--k0qxI`,
	"selected": `AppDrawer-module__selected--dEuBK`,
	"menuItemIcon": `AppDrawer-module__menuItemIcon--d1mdT`,
	"menuItemText": `AppDrawer-module__menuItemText--bigE4`,
	"menuHeaderOpen": `AppDrawer-module__menuHeaderOpen--_VCmd`,
	"logoContainer": `AppDrawer-module__logoContainer--SZV1q`,
	"menuHeaderClose": `AppDrawer-module__menuHeaderClose--tQ4ie`,
	"iconMenu": `AppDrawer-module__iconMenu--hTPZY`,
	"newIcon": `AppDrawer-module__newIcon--y28yo`,
	"hasUnreadMessages": `AppDrawer-module__hasUnreadMessages--FVdJo`
};
export default ___CSS_LOADER_EXPORT___;
